import { IGetUserByPlantEmail } from 'interfaces/TeamSale/TeamSale';
import * as UserQuery from './GraphQL/Queries/userQuery';
import {
  GET_USERS,
  IUpdateUserRoleParams,
  IUserParams,
} from './GraphQL/Variables/user';
import axiosGraphQL from './GraphQL/axiosGraphQL';

export const UserApi = {
  getAllUser: async (params: IUserParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: UserQuery.GET_ALL_USER,
      variables: GET_USERS.getAllUser(params),
    });
  },
  getUsersNotTeamSale: async (value: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: UserQuery.GET_USERS_NOT_TEAM_SALE,
      variables: GET_USERS.getUsersNotTeamSale({
        activeRoute: false,
        contains: value,
      }),
    });
  },
  updateUserRole: async (params: IUpdateUserRoleParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: UserQuery.UPDATE_USER_ROLE,
      variables: GET_USERS.updateUserRole(params),
    });
  },
  getUserByPlantEmail: (params: IGetUserByPlantEmail) => {
    return axiosGraphQL.post('/graphql', {
      query: UserQuery.GET_USER_BY_PLANT_EMAIL,
      variables: GET_USERS.getUserByPlantEmail(params),
    });
  },
};
